<template>
  <div
    v-tooltip="{ content: capitalize(tooltip), delay: 500 }"
    class="expand-button-container"
    @click="toggle">
    <div
      class="expand-button"
      :class="{ expanded }">
      <HSButton
        :variant="'secondary'"
        :rounded="true"
        :borderless="true"
        :icon-left="markRaw(IconArrowDown)" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { capitalize, computed, markRaw, ref, watch } from 'vue';
  import { useI18n } from 'vue-i18n';

  import HSButton from '@/common/components/ui/Button/Button.vue';
  import { IconArrowDown } from '@/common/icons/monochrome';

  const i18n = useI18n();

  interface IProps {
    modelValue: boolean;
  }

  const { modelValue } = defineProps<IProps>();

  interface IEmits {
    (e: 'update:modelValue', value: boolean): void;
  }

  const emits = defineEmits<IEmits>();

  const expanded = ref(modelValue);

  const tooltip = computed(() => (expanded.value ? i18n.t('actions.collapse') : i18n.t('actions.expand')));

  function toggle() {
    expanded.value = !expanded.value;
    emits('update:modelValue', expanded.value);
  }

  watch(
    () => modelValue,
    (val) => {
      expanded.value = val;
    },
  );
</script>

<style scoped lang="scss">
  @use '@/styles/variables' as *;

  .expand-button-container {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .expand-button {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      transition: transform 0.3s ease;
      transform: rotate(-90deg);

      &.expanded {
        transform: rotate(0deg);
        transition: transform 0.3s ease;
      }

      :deep(.btn) {
        padding: 0.4rem !important;
      }
      :deep(.btn svg) {
        width: 1.4rem !important;
      }
    }
  }
</style>
